import { InjectionToken } from "@angular/core";

export const TABLE_CUSTOM_TEMPLATE_CONTEXT = new InjectionToken<{ [key: string]: any }>(
  "Context from table custom template"
);
